import * as Comp from './group.styles'

import { Divider } from '../divider'

type GroupProps = {
  children: React.ReactNode
  title?: string
}

export function Group({ children, title }: GroupProps) {
  const hasTitle = !!title?.length

  return (
    <Comp.Container>
      <Divider />

      <Comp.Wrapper>
        {hasTitle && <Comp.Title>{title}</Comp.Title>}
      </Comp.Wrapper>

      {children}
    </Comp.Container>
  )
}
